import React from "react";
import { useNavigate } from "react-router-dom";
import "./Categories.css";
import { defaultHomeSettings, normalizeHomeSettings } from "../utils/homeContent";

function Categories({ settings }) {
  const navigate = useNavigate();
  const homeSettings = normalizeHomeSettings(settings || defaultHomeSettings);

  return (
    <section className="category-section">
      <div className="category-shell">
        <div className="category-heading">
          <p className="category-eyebrow">Quick Access</p>
          <h2 className="category-title">{homeSettings.categories_section_title}</h2>
          <p className="category-subtitle">{homeSettings.categories_section_subtitle}</p>
        </div>

        <div className="category-grid">
          {homeSettings.categories.map((item) => (
            <button key={item.title} type="button" className="category-card" onClick={() => navigate(item.path)}>
              <div className="category-icon">
                <i className={`bi ${item.icon}`}></i>
              </div>
              <h5>{item.title}</h5>
              <p>{item.helper}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;
